<div class="newpost-choose my-4">
  <div class="discovery-hint-box">
    <label class="custom-checkbox">
      {{ watermarkLabel }}
      <input type="checkbox" [checked]="watermark" (change)="onToggleWatermark($event)" class="form-control" />
      <span class="checkmark checkmark-md" [ngClass]="{'icon-liteicon-black-tick': watermark}"></span>
    </label>
    <app-info-icon [message]="hint"></app-info-icon>
  </div>

  <div *ngIf="watermark" class="walletform-container watermark-controls mt-4 p-0 newpost-description watermark-style"
    [ngClass]="{'in-video': isVideo}"
  >
    <div class="form-group d-flex gap-2 mb-4">
      <input type="text" class="form-control watermark-input" [(ngModel)]="globalWatermark.text" name="watermarkText"
        [ngModelOptions]="{standalone: true}" (ngModelChange)="applyGlobalWatermark()" maxlength="30" />
    </div>
    <div class="walletform-content form-group d-flex gap-3 mb-4">
      <ng-select class="watermark-location" [items]="locationOptions" bindLabel="label" bindValue="value"
        [ngModelOptions]="{standalone: true}" [(ngModel)]="globalWatermark.location"
        (ngModelChange)="applyGlobalWatermark()">
      </ng-select>
      <div *ngIf="!isVideo" class="form-theme-control">
        <div [style.background]="globalWatermark.color" class="color-pickers"></div>
        <div class="color-code">{{ globalWatermark.color }}</div>
        <div class="color-icon">
          <span class="iconRing"></span>
          <span class="iconRing"></span>
          <input [(colorPicker)]="globalWatermark.color" [cpOutputFormat]="'hex'"
            (colorPickerChange)="onChangeWatermarkColor($event)" class="form-control" id="colorpicker" />
        </div>
      </div>
    </div>
    <div class="d-flex" *ngIf="!isVideo">
      <div class="flex-fill d-flex flex-column align-items-center mx-1 mb-2 mb-md-0 watermark-range-container">
        <input type="range" class="form-range watermark-range" min="0" max="1" step="0.05" [(ngModel)]="globalWatermark.alpha" name="watermarkAlpha" [ngModelOptions]="{standalone: true}" (ngModelChange)="applyGlobalWatermark()" />
        <label class="text-light text-center mt-1">{{NEW_POST_CONST.OPACITY}}</label>
      </div>
      <div *ngIf="globalWatermark.location === LOCATIONS.DIAGONAL" class="flex-fill d-flex flex-column align-items-center mx-1 mb-2 mb-md-0 watermark-range-container">
        <input type="range" class="form-range watermark-range" min="1" max="8" step="0.1" [(ngModel)]="globalWatermark.space" name="watermarkSpace" [ngModelOptions]="{standalone: true}" (ngModelChange)="applyGlobalWatermark()" />
        <label class="text-light text-center mt-1">{{NEW_POST_CONST.GAP}}</label>
      </div>
      <div class="flex-fill d-flex flex-column align-items-center mx-1 mb-2 mb-md-0 watermark-range-container">
        <input type="range" class="form-range watermark-range" min="16" max="96" step="1" [(ngModel)]="globalWatermark.size" name="watermarkSize" [ngModelOptions]="{standalone: true}" (ngModelChange)="applyGlobalWatermark()" />
        <label class="text-light text-center mt-1">{{NEW_POST_CONST.FONT_SIZE}}</label>
      </div>
    </div>
  </div>
</div>
